import { OrgStructurePage } from '@hq/org-admin';
import { hq } from '../session';

/**
 * 仓库与科室（平台侧跨租户，门禁 sys:org:manage）。
 * 页面实现收敛在 `@hq/org-admin`，本端开启租户维度。
 */
export default function OrgStructure() {
  return <OrgStructurePage platform hq={hq} />;
}
